export const LP_NODE_TYPES = {
  marketplaceEntity: 'CreditCardsLPMarketplaceEntity',
  rewardsList: 'CreditCardsLPRewardsList',
  rewardsTile: 'CreditCardsLPRewardsTile',
  offerBlock: 'CreditCardsLPOfferBlock',
  offerBlockTitle: 'CreditCardsLPOfferBlockTitle',
  offerBlockBody: 'CreditCardsLPOfferBlockBody',
  offerBlockDisclaimer: 'CreditCardsLPOfferBlockDisclaimer',
  cardList: 'CreditCardsLPCardList',
  cardListItem: 'CreditCardsLPCardListItem',
  expertTake: 'CreditCardsLPExpertTake',
} as const;

export const LP_PAGE_DATA_FIELD = 'page_data';

export const LP_EXPERT_TAKE_FIELD = 'expert_take';
